/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: loggedOutPricingPagePlansQuery
// ====================================================

export interface loggedOutPricingPagePlansQuery_planStacks_plans_features {
  /**
   * Optional URL to navigate to when feature is clicked.
   */
  href: string | null;
  /**
   * Feature name
   */
  name: string;
  /**
   * Long feature description
   */
  tooltip: string | null;
}

export interface loggedOutPricingPagePlansQuery_planStacks_plans_tiers {
  /**
   * Max number of tasks to be in tier (-1 for infinity)
   */
  numTasks: number;
  /**
   * Price per task in tier
   */
  pricePerTask: number;
}

export interface loggedOutPricingPagePlansQuery_planStacks_plans {
  /**
   * Plan allows company features
   */
  allowCompanies: boolean;
  /**
   * Amount per interval
   */
  amount: number;
  /**
   * Long description of plan
   */
  description: string | null;
  /**
   * Features included in plan
   * Mostly used to show features list and tooltips
   */
  features: loggedOutPricingPagePlansQuery_planStacks_plans_features[];
  /**
   * Plan allows auto replay of tasks
   */
  hasAutoReplay: boolean;
  /**
   * Plan allows metered billing
   */
  hasMeteredBilling: boolean;
  /**
   * Plan allows multi-step zaps
   */
  hasMultiStepZaps: boolean;
  /**
   * Plan allows paths
   */
  hasPaths: boolean;
  /**
   * Plan allows premium apps
   */
  hasPremiumApps: boolean;
  /**
   * Plan allows teams
   */
  hasTeams: boolean;
  id: string;
  /**
   * The plan billing interval
   */
  interval: BillingInterval;
  /**
   * Plan is a member of a plan group
   */
  isInPlanGroup: boolean;
  /**
   * Member limit for team-enabled accounts
   */
  memberLimit: number;
  /**
   * Plan name
   */
  name: string;
  /**
   * Plan task limit
   */
  tasks: number;
  /**
   * Tiers of per-task costs for plans with metered billing
   */
  tiers: loggedOutPricingPagePlansQuery_planStacks_plans_tiers[];
  /**
   * The type this plan belongs to
   * e.g. Starter
   */
  type: string;
  /**
   * Plan zap limit
   */
  zaps: number;
  /**
   * How often zaps are evaluated in minutes
   */
  zapsRunInterval: number;
  /**
   * The changeType for this particular plan from the user's current plan
   */
  changeType: ChangePlanType;
}

export interface loggedOutPricingPagePlansQuery_planStacks {
  id: string;
  planType: string;
  plans: loggedOutPricingPagePlansQuery_planStacks_plans[];
}

export interface loggedOutPricingPagePlansQuery {
  /**
   * Get plans for the account in a format to display on pricing page v3 (plans with task variants).
   * If no accountId is specified, returns the plans for the default plan group.
   *
   * Note that variant and identity are no longer used, and will be removed.
   */
  planStacks: loggedOutPricingPagePlansQuery_planStacks[];
}

export interface loggedOutPricingPagePlansQueryVariables {
  accountId?: number | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: accountCurrencyQuery
// ====================================================

export interface accountCurrencyQuery_account {
  id: number;
  /**
   * Currency, for billing purposes
   */
  currency: string | null;
}

export interface accountCurrencyQuery {
  account: accountCurrencyQuery_account;
}

export interface accountCurrencyQueryVariables {
  accountId: number;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: accountSwitchQuery
// ====================================================

export interface accountSwitchQuery_account {
  id: number;
  /**
   * Object containing Gargoyle switches that may apply to the account
   */
  switches: any;
}

export interface accountSwitchQuery {
  account: accountSwitchQuery_account;
}

export interface accountSwitchQueryVariables {
  accountId: number;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: pricingPage_currenciesQuery
// ====================================================

export interface pricingPage_currenciesQuery_currencies {
  /**
   * The ID of this currency.
   */
  id: string;
  /**
   * The country icon to display alongside the currency.
   */
  icon: string;
  /**
   * To determine the value of a price in another currency, take the USD value
   * and multiply it by this value.
   */
  multiplier: number;
  /**
   * Short form name of the currency.
   */
  name: string;
  /**
   * Character symbol that represents the currency.
   */
  symbol: string;
  /**
   * Whether or not the currency is zero-decimal/decimal-less
   */
  zeroDecimal: boolean;
}

export interface pricingPage_currenciesQuery {
  /**
   * Returns the list of currencies we support on Zapier.com.
   */
  currencies: pricingPage_currenciesQuery_currencies[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: currentAccountQuery
// ====================================================

export interface currentAccountQuery_account_planV2 {
  /**
   * Plan name
   */
  name: string;
  /**
   * Long description of plan
   */
  description: string | null;
  /**
   * Amount per interval
   */
  amount: number;
}

export interface currentAccountQuery_account {
  /**
   * Account name
   */
  name: string;
  id: number;
  /**
   * True if the account is paying us money
   */
  isPaying: boolean;
  /**
   * Currency, for billing purposes
   */
  currency: string | null;
  /**
   * True if the account is on a free trial
   */
  isTrialing: boolean;
  /**
   * Is this user trialing teams features?
   */
  isTrialingTeams: boolean;
  /**
   * Is this user trialing companies features?
   */
  isTrialingCompanies: boolean;
  /**
   * Payment PlanV2 account is subscribed to
   */
  planV2: currentAccountQuery_account_planV2;
}

export interface currentAccountQuery {
  account: currentAccountQuery_account;
}

export interface currentAccountQueryVariables {
  accountId: number;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: currentUserQuery
// ====================================================

export interface currentUserQuery_currentUser {
  /**
   * The (customuser) ID of this user.
   */
  id: string;
  /**
   * The email that this user used to sign up for Zapier.
   */
  email: string;
  /**
   * The full name of this user.
   */
  fullName: string | null;
  /**
   * Gargoyle switch listing
   */
  switches: any;
}

export interface currentUserQuery {
  /**
   * Returns currently logged in User
   */
  currentUser: currentUserQuery_currentUser | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: eligibilityQuery
// ====================================================

export interface eligibilityQuery_account_plan {
  /**
   * Plan allows company features
   */
  allowCompanies: boolean;
  /**
   * Plan allows teams
   */
  hasTeams: boolean;
  id: string;
  /**
   * The type this plan belongs to
   * e.g. Starter
   */
  type: string;
}

export interface eligibilityQuery_account {
  /**
   * End date for the company free trial, if it exists
   */
  companiesTrialEndDate: string | null;
  /**
   * The date the account's company trial ended
   */
  companyAccountEndDate: string | null;
  /**
   * Current user's role on account
   */
  currentUserRole: MemberRole;
  /**
   * True if the account used to be on a company free trial
   */
  hasBeenInCompaniesTrial: boolean | null;
  id: number;
  /**
   * Is this user trialing teams features?
   */
  isTrialingTeams: boolean;
  /**
   * Is this user trialing companies features?
   */
  isTrialingCompanies: boolean;
  /**
   * Payment PlanV2 account is subscribed to
   */
  plan: eligibilityQuery_account_plan;
  /**
   * End date for the team account, if it exists
   */
  teamAccountEndDate: string | null;
  /**
   * End date for the team free trial, if it exists
   */
  teamTrialEndDate: string | null;
}

export interface eligibilityQuery {
  account: eligibilityQuery_account;
}

export interface eligibilityQueryVariables {
  accountId: number;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: getPlanGroupFeaturesQuery
// ====================================================

export interface getPlanGroupFeaturesQuery_planGroupFeatureList_features {
  /**
   * Feature name
   */
  name: string;
  /**
   * Optional URL to navigate to when feature is clicked.
   */
  href: string | null;
  /**
   * Long feature description
   */
  tooltip: string | null;
  /**
   * Feature value for Free plan
   */
  Free: string | null;
  /**
   * Feature value for Starter plan
   */
  Starter: string | null;
  /**
   * Feature value for Professional plan
   */
  Professional: string | null;
  /**
   * Feature value for Team plan
   */
  Team: string | null;
  /**
   * Feature value for Company plan
   */
  Company: string | null;
}

export interface getPlanGroupFeaturesQuery_planGroupFeatureList {
  category: string | null;
  features:
    | (getPlanGroupFeaturesQuery_planGroupFeatureList_features | null)[]
    | null;
}

export interface getPlanGroupFeaturesQuery {
  /**
   * List of feature enrollment
   */
  planGroupFeatureList:
    | (getPlanGroupFeaturesQuery_planGroupFeatureList | null)[]
    | null;
}

export interface getPlanGroupFeaturesQueryVariables {
  accountId?: string | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: plansQuery
// ====================================================

export interface plansQuery_planStacks_plans_features {
  /**
   * Optional URL to navigate to when feature is clicked.
   */
  href: string | null;
  /**
   * Feature name
   */
  name: string;
  /**
   * Long feature description
   */
  tooltip: string | null;
}

export interface plansQuery_planStacks_plans_tiers {
  /**
   * Max number of tasks to be in tier (-1 for infinity)
   */
  numTasks: number;
  /**
   * Price per task in tier
   */
  pricePerTask: number;
}

export interface plansQuery_planStacks_plans {
  /**
   * Plan allows company features
   */
  allowCompanies: boolean;
  /**
   * Amount per interval
   */
  amount: number;
  /**
   * Long description of plan
   */
  description: string | null;
  /**
   * Features included in plan
   * Mostly used to show features list and tooltips
   */
  features: plansQuery_planStacks_plans_features[];
  /**
   * Plan allows auto replay of tasks
   */
  hasAutoReplay: boolean;
  /**
   * Plan allows metered billing
   */
  hasMeteredBilling: boolean;
  /**
   * Plan allows multi-step zaps
   */
  hasMultiStepZaps: boolean;
  /**
   * Plan allows paths
   */
  hasPaths: boolean;
  /**
   * Plan allows premium apps
   */
  hasPremiumApps: boolean;
  /**
   * Plan allows teams
   */
  hasTeams: boolean;
  id: string;
  /**
   * The plan billing interval
   */
  interval: BillingInterval;
  /**
   * Plan is a member of a plan group
   */
  isInPlanGroup: boolean;
  /**
   * Member limit for team-enabled accounts
   */
  memberLimit: number;
  /**
   * Plan name
   */
  name: string;
  /**
   * Plan task limit
   */
  tasks: number;
  /**
   * Tiers of per-task costs for plans with metered billing
   */
  tiers: plansQuery_planStacks_plans_tiers[];
  /**
   * The type this plan belongs to
   * e.g. Starter
   */
  type: string;
  /**
   * Plan zap limit
   */
  zaps: number;
  /**
   * How often zaps are evaluated in minutes
   */
  zapsRunInterval: number;
  /**
   * The changeType for this particular plan from the user's current plan
   */
  changeType: ChangePlanType;
}

export interface plansQuery_planStacks {
  id: string;
  planType: string;
  plans: plansQuery_planStacks_plans[];
}

export interface plansQuery {
  /**
   * Get plans for the account in a format to display on pricing page v3 (plans with task variants).
   * If no accountId is specified, returns the plans for the default plan group.
   *
   * Note that variant and identity are no longer used, and will be removed.
   */
  planStacks: plansQuery_planStacks[];
}

export interface plansQueryVariables {
  accountId?: number | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: accountQuery
// ====================================================

export interface accountQuery_account_plan_features {
  /**
   * Optional URL to navigate to when feature is clicked.
   */
  href: string | null;
  /**
   * Feature name
   */
  name: string;
  /**
   * Long feature description
   */
  tooltip: string | null;
}

export interface accountQuery_account_plan_tiers {
  /**
   * Max number of tasks to be in tier (-1 for infinity)
   */
  numTasks: number;
  /**
   * Price per task in tier
   */
  pricePerTask: number;
}

export interface accountQuery_account_plan {
  /**
   * Plan allows company features
   */
  allowCompanies: boolean;
  /**
   * Amount per interval
   */
  amount: number;
  /**
   * Long description of plan
   */
  description: string | null;
  /**
   * Features included in plan
   * Mostly used to show features list and tooltips
   */
  features: accountQuery_account_plan_features[];
  /**
   * Plan allows auto replay of tasks
   */
  hasAutoReplay: boolean;
  /**
   * Plan allows metered billing
   */
  hasMeteredBilling: boolean;
  /**
   * Plan allows multi-step zaps
   */
  hasMultiStepZaps: boolean;
  /**
   * Plan allows paths
   */
  hasPaths: boolean;
  /**
   * Plan allows premium apps
   */
  hasPremiumApps: boolean;
  /**
   * Plan allows teams
   */
  hasTeams: boolean;
  id: string;
  /**
   * The plan billing interval
   */
  interval: BillingInterval;
  /**
   * Plan is a member of a plan group
   */
  isInPlanGroup: boolean;
  /**
   * Member limit for team-enabled accounts
   */
  memberLimit: number;
  /**
   * Plan name
   */
  name: string;
  /**
   * Plan task limit
   */
  tasks: number;
  /**
   * Tiers of per-task costs for plans with metered billing
   */
  tiers: accountQuery_account_plan_tiers[];
  /**
   * The type this plan belongs to
   * e.g. Starter
   */
  type: string;
  /**
   * Plan zap limit
   */
  zaps: number;
  /**
   * How often zaps are evaluated in minutes
   */
  zapsRunInterval: number;
  /**
   * The changeType for this particular plan from the user's current plan
   */
  changeType: ChangePlanType;
}

export interface accountQuery_account {
  id: number;
  /**
   * The ID of the user's current plan group
   */
  planGroupId: string | null;
  /**
   * Payment PlanV2 account is subscribed to
   */
  plan: accountQuery_account_plan;
}

export interface accountQuery {
  account: accountQuery_account;
}

export interface accountQueryVariables {
  accountId: number;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: offerQuery
// ====================================================

export interface offerQuery_account_offer_variant_campaign {
  id: string;
  maxUses: number;
  name: string;
  slug: string;
}

export interface offerQuery_account_offer_variant_destinationPlan {
  amount: number;
  displayShortName: string | null;
  id: string;
  interval: string;
  name: string;
}

export interface offerQuery_account_offer_variant_promotionPlanGroup {
  id: string;
  name: string;
}

export interface offerQuery_account_offer_variant {
  id: string;
  campaign: offerQuery_account_offer_variant_campaign;
  /**
   * The plan the user will end up after accepting the offer. Used with single-interval
   * offers.
   */
  destinationPlan: offerQuery_account_offer_variant_destinationPlan | null;
  /**
   * The plan group the promotional plan is in, if applicable. Used for allowing the user
   * to choose between billing intervals.
   */
  promotionPlanGroup: offerQuery_account_offer_variant_promotionPlanGroup | null;
  /**
   * True if this variant is an experiment control group.
   */
  isControl: boolean;
  monthlyCost: number;
  name: string;
  terms: string | null;
  totalCost: number;
}

export interface offerQuery_account_offer {
  id: string;
  acceptedAt: string | null;
  accountId: string;
  createdAt: string | null;
  /**
   * The datetime the offer is no longer allowed to be accepted.
   */
  expiry: string | null;
  variant: offerQuery_account_offer_variant;
}

export interface offerQuery_account {
  id: number;
  /**
   * The ID of the account's active offer, if there is one
   */
  activeOfferId: string | null;
  /**
   * Retrieves a specific offer
   */
  offer: offerQuery_account_offer | null;
  /**
   * The planGroupId of the promotional plan the user is currently on, if any
   */
  promotionPlanGroupId: string | null;
}

export interface offerQuery {
  account: offerQuery_account;
}

export interface offerQueryVariables {
  accountId: number;
  offerId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: promotions_currentPlanQuery
// ====================================================

export interface promotions_currentPlanQuery_account_currentPlan {
  id: string;
  /**
   * The plan billing interval
   */
  interval: BillingInterval;
}

export interface promotions_currentPlanQuery_account {
  id: number;
  /**
   * Payment PlanV2 account is subscribed to
   */
  currentPlan: promotions_currentPlanQuery_account_currentPlan;
}

export interface promotions_currentPlanQuery {
  account: promotions_currentPlanQuery_account;
}

export interface promotions_currentPlanQueryVariables {
  accountId: number;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: currencyQuery
// ====================================================

export interface currencyQuery_currencies {
  /**
   * The ID of this currency.
   */
  id: string;
  /**
   * The country icon to display alongside the currency.
   */
  icon: string;
  /**
   * To determine the value of a price in another currency, take the USD value
   * and multiply it by this value.
   */
  multiplier: number;
  /**
   * Short form name of the currency.
   */
  name: string;
  /**
   * Character symbol that represents the currency.
   */
  symbol: string;
  /**
   * Whether or not the currency is zero-decimal/decimal-less
   */
  zeroDecimal: boolean;
}

export interface currencyQuery {
  /**
   * Returns the list of currencies we support on Zapier.com.
   */
  currencies: currencyQuery_currencies[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: invoices
// ====================================================

export interface invoices_account_invoices {
  id: string;
  /**
   * Datetime Invoice was created
   */
  createdAt: string;
  /**
   * Is the payment for the Invoice pending
   */
  hasPendingPayment: boolean;
}

export interface invoices_account {
  id: number;
  /**
   * Get a list of invoices on an account
   */
  invoices: invoices_account_invoices[];
}

export interface invoices {
  account: invoices_account;
}

export interface invoicesVariables {
  accountId: number;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: isAuthenticated
// ====================================================

export interface isAuthenticated {
  /**
   * Returns `true` if the user is logged in to Zapier, `false` if not.
   */
  isAuthenticated: boolean;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: promotions_offersForCampaignQuery
// ====================================================

export interface promotions_offersForCampaignQuery_account_campaignOffers {
  acceptedAt: string | null;
  accountId: string;
  /**
   * The datetime the offer is no longer allowed to be accepted.
   */
  expiry: string | null;
  id: string;
}

export interface promotions_offersForCampaignQuery_account {
  /**
   * Retrieves offers by campaign slug
   */
  campaignOffers:
    | (promotions_offersForCampaignQuery_account_campaignOffers | null)[]
    | null;
  id: number;
}

export interface promotions_offersForCampaignQuery {
  account: promotions_offersForCampaignQuery_account;
}

export interface promotions_offersForCampaignQueryVariables {
  accountId: number;
  campaignSlug: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: FullStoryUser
// ====================================================

export interface FullStoryUser_account_plan {
  id: string;
  /**
   * Plan name
   */
  name: string;
}

export interface FullStoryUser_account {
  id: number;
  /**
   * Payment Plan Account is subscribed to
   * (use if only getting small parts of the plan that are available in the
   * accounts listing endpoint to avoid cross-realm calls otherwise use plansV2)
   */
  plan: FullStoryUser_account_plan;
  /**
   * Object containing Gargoyle switches that may apply to the account
   */
  switches: any;
}

export interface FullStoryUser_currentUserV2_roles {
  accountId: string;
  role: MemberRole;
}

export interface FullStoryUser_currentUserV2 {
  /**
   * The email that this user used to sign up for Zapier.
   */
  email: string;
  /**
   * The full name of this user.
   */
  fullName: string | null;
  /**
   * The (customuser) ID of this user.
   */
  id: string;
  /**
   * Account Roles
   */
  roles: FullStoryUser_currentUserV2_roles[];
  /**
   * Gargoyle switch listing
   */
  switches: any;
}

export interface FullStoryUser {
  account: FullStoryUser_account;
  /**
   * Returns currently logged in User
   */
  currentUserV2: FullStoryUser_currentUserV2 | null;
}

export interface FullStoryUserVariables {
  accountId: number;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: pricingPage_planFragment
// ====================================================

export interface pricingPage_planFragment_features {
  /**
   * Optional URL to navigate to when feature is clicked.
   */
  href: string | null;
  /**
   * Feature name
   */
  name: string;
  /**
   * Long feature description
   */
  tooltip: string | null;
}

export interface pricingPage_planFragment_tiers {
  /**
   * Max number of tasks to be in tier (-1 for infinity)
   */
  numTasks: number;
  /**
   * Price per task in tier
   */
  pricePerTask: number;
}

export interface pricingPage_planFragment {
  /**
   * Plan allows company features
   */
  allowCompanies: boolean;
  /**
   * Amount per interval
   */
  amount: number;
  /**
   * Long description of plan
   */
  description: string | null;
  /**
   * Features included in plan
   * Mostly used to show features list and tooltips
   */
  features: pricingPage_planFragment_features[];
  /**
   * Plan allows auto replay of tasks
   */
  hasAutoReplay: boolean;
  /**
   * Plan allows metered billing
   */
  hasMeteredBilling: boolean;
  /**
   * Plan allows multi-step zaps
   */
  hasMultiStepZaps: boolean;
  /**
   * Plan allows paths
   */
  hasPaths: boolean;
  /**
   * Plan allows premium apps
   */
  hasPremiumApps: boolean;
  /**
   * Plan allows teams
   */
  hasTeams: boolean;
  id: string;
  /**
   * The plan billing interval
   */
  interval: BillingInterval;
  /**
   * Plan is a member of a plan group
   */
  isInPlanGroup: boolean;
  /**
   * Member limit for team-enabled accounts
   */
  memberLimit: number;
  /**
   * Plan name
   */
  name: string;
  /**
   * Plan task limit
   */
  tasks: number;
  /**
   * Tiers of per-task costs for plans with metered billing
   */
  tiers: pricingPage_planFragment_tiers[];
  /**
   * The type this plan belongs to
   * e.g. Starter
   */
  type: string;
  /**
   * Plan zap limit
   */
  zaps: number;
  /**
   * How often zaps are evaluated in minutes
   */
  zapsRunInterval: number;
  /**
   * The changeType for this particular plan from the user's current plan
   */
  changeType: ChangePlanType;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: offerVariantFragment
// ====================================================

export interface offerVariantFragment_campaign {
  id: string;
  maxUses: number;
  name: string;
  slug: string;
}

export interface offerVariantFragment_destinationPlan {
  amount: number;
  displayShortName: string | null;
  id: string;
  interval: string;
  name: string;
}

export interface offerVariantFragment_promotionPlanGroup {
  id: string;
  name: string;
}

export interface offerVariantFragment {
  id: string;
  campaign: offerVariantFragment_campaign;
  /**
   * The plan the user will end up after accepting the offer. Used with single-interval
   * offers.
   */
  destinationPlan: offerVariantFragment_destinationPlan | null;
  /**
   * The plan group the promotional plan is in, if applicable. Used for allowing the user
   * to choose between billing intervals.
   */
  promotionPlanGroup: offerVariantFragment_promotionPlanGroup | null;
  /**
   * True if this variant is an experiment control group.
   */
  isControl: boolean;
  monthlyCost: number;
  name: string;
  terms: string | null;
  totalCost: number;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

export enum BillingInterval {
  month = "month",
  year = "year",
}

export enum ChangePlanType {
  change = "change",
  downgrade = "downgrade",
  upgrade = "upgrade",
}

export enum MemberRole {
  admin = "admin",
  member = "member",
  owner = "owner",
  super_admin = "super_admin",
}

//==============================================================
// END Enums and Input Objects
//==============================================================
